<template>
  <v-bottom-sheet
    v-model="show"
    :hide-overlay="true"
    content-class="mx-0 my-0"
  >
    <div class="primary white--text px-2 py-2 text-center subtitle-1">
      New version is available!
      <v-btn
        class="ml-2"
        x-small
        :loading="isRefreshing"
        @click="handleRefreshClick"
      >
        Refresh
      </v-btn>
    </div>
  </v-bottom-sheet>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { State } from 'vuex-class'

@Component
export default class NewVersionAvailable extends Vue {

  @State(state => state.showNewVersionAvailable) show: boolean
  isRefreshing: boolean = false

  handleRefreshClick () {
    this.isRefreshing = true
    window.location.reload()
  }
}
</script>
<style lang="scss" scoped>

</style>
